import type { Engine } from '../types';
import { buildUrl } from '../url';
import { priceParam } from './shared';

// Walmart packs its filters into one `facet` param, joined with `||`
// (facet=fulfillment_method:Pickup||brand:...). Sort and price are plain
// params. Walmart blocks automated browsers, so the weekly check can't load
// it; values come from real Walmart URLs.
export const walmart: Engine = {
  id: 'walmart',
  name: 'Walmart',
  bang: 'wm',
  aliases: ['walmart'],
  homepage: 'https://www.walmart.com',
  category: 'Shopping',
  description: 'Products by price, pickup, delivery or shipping, and sort.',
  experimental: true,
  params: [
    priceParam,
    {
      id: 'fulfillment',
      type: 'choice',
      label: 'How you get it',
      group: 'Filters',
      options: [
        { value: 'Pickup', token: 'pickup', label: 'Pickup' },
        { value: 'Delivery', token: 'delivery', label: 'Delivery' },
        { value: 'Shipping', token: 'ship', label: 'Shipping' },
      ],
    },
    {
      id: 'sort',
      type: 'choice',
      label: 'Sort',
      group: 'Sort',
      options: [
        { value: 'price_low', token: 'low', label: 'Price: low to high' },
        { value: 'price_high', token: 'high', label: 'Price: high to low' },
        { value: 'rating_high', token: 'rated', label: 'Customer rating' },
        { value: 'new', token: 'newest', label: 'New arrivals' },
        { value: 'best_seller', token: 'pop', label: 'Best sellers' },
      ],
    },
  ],
  build({ query, values }) {
    const facets: string[] = [];
    if (typeof values.fulfillment === 'string')
      facets.push(`fulfillment_method:${values.fulfillment}`);
    const price = typeof values.price === 'object' ? values.price : undefined;
    return buildUrl('https://www.walmart.com/search', {
      q: query,
      facet: facets.join('||') || undefined,
      min_price: price?.min,
      max_price: price?.max,
      sort: values.sort as string | undefined,
    });
  },
};
